export enum ProgramFavoriteTypeEnum {
    LOCATION = 'LOCATION',
    METHOD = 'METHODS',
    VARIABLE = 'VARIABLES'
}
